"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var BlockedIcon = function BlockedIcon(props) {
  return _react["default"].createElement("svg", (0, _extends2["default"])({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M0 0h24v24H0z"
  }), _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M5.747 7.016A7.961 7.961 0 0 0 4 12c0 4.411 3.589 8 8 8a7.961 7.961 0 0 0 4.984-1.747L5.747 7.016zm.244-.292l.733-.733c-.26.228-.505.473-.733.733zM7.179 5.62l11.201 11.2A7.959 7.959 0 0 0 20 12c0-4.411-3.589-8-8-8-1.809 0-3.48.604-4.821 1.62zM12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2z"
  })));
};

BlockedIcon.defaultProps = {
  width: "24px",
  height: "24px",
  "aria-label": "Wrong",
  color: "#B30021"
};
var _default = BlockedIcon;
exports["default"] = _default;